import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import MobileNav from './MobileNav'

const navLinks = [
  { label: 'Overview', href: '/overview' },
  { label: 'Features', href: '/features' },
  { label: 'Demo', href: '/demo' },
  { label: 'About', href: '/about' },
  { label: 'Pricing', href: '/pricing' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  return (
    <>
      <nav className="sticky top-0 z-[100] w-full bg-brand-dark/80 backdrop-blur-[20px] border-b border-white/[0.06] px-6">
        <div className="max-w-[1200px] mx-auto flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 no-underline" onClick={closeMobileMenu}>
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none">
              <defs>
                <linearGradient id="gradLogo" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#2dd4bf" />
                  <stop offset="100%" stopColor="#10b981" />
                </linearGradient>
              </defs>
              <path
                d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
                fill="url(#gradLogo)"
              />
              <circle cx="18" cy="5" r="1.5" fill="#2dd4bf" />
              <circle cx="6" cy="18" r="1" fill="#10b981" />
            </svg>
            <div className="font-serif text-[22px] font-medium tracking-[-0.02em] text-brand-light">
              Wealth<span className="text-accent-tealLight">Space</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden min-[900px]:flex gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`relative text-[15px] font-medium transition-colors duration-300 no-underline
                  ${location.pathname === link.href ? 'text-brand-light' : 'text-brand-muted hover:text-brand-light'}
                  after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:bg-accent-teal
                  after:transition-[width] after:duration-300
                  ${location.pathname === link.href ? 'after:w-full' : 'after:w-0 hover:after:w-full'}
                `}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <Link
            to="/get-started"
            className="hidden min-[900px]:inline-flex items-center gap-2 bg-gradient-to-br from-accent-teal to-emerald-500 text-brand-darkAlt px-6 py-3 rounded-md font-semibold text-sm transition-all duration-300 shadow-button hover:-translate-y-0.5 hover:shadow-button-hover no-underline"
          >
            Get Started
          </Link>

          {/* Hamburger Button - Mobile */}
          <button
            className="min-[900px]:hidden flex flex-col justify-center items-center w-11 h-11 bg-white/5 border border-white/10 rounded-lg cursor-pointer gap-[5px]"
            onClick={toggleMobileMenu}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
          >
            <span
              className={`block w-5 h-[2px] bg-brand-light rounded-sm transition-all duration-300
                ${mobileMenuOpen ? 'rotate-45 translate-x-[5px] translate-y-[5px]' : ''}
              `}
            />
            <span
              className={`block w-5 h-[2px] bg-brand-light rounded-sm transition-opacity duration-300
                ${mobileMenuOpen ? 'opacity-0' : ''}
              `}
            />
            <span
              className={`block w-5 h-[2px] bg-brand-light rounded-sm transition-all duration-300
                ${mobileMenuOpen ? '-rotate-45 translate-x-[5px] -translate-y-[5px]' : ''}
              `}
            />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <MobileNav isOpen={mobileMenuOpen} onClose={closeMobileMenu} links={navLinks} />
    </>
  )
}
